import React from 'react';
import { MagnifyingGlassIcon, FunnelIcon } from '@heroicons/react/24/outline';
import { HEALTH_PERIOD_OPTIONS, type HealthPeriod } from '../../../services/phoneNumberHealthService';

interface Props {
  search: string;
  onSearchChange: (v: string) => void;
  healthFilter: string;
  onHealthFilterChange: (v: string) => void;
  usageFilter: string;
  onUsageFilterChange: (v: string) => void;
  tzFilter: string;
  onTzFilterChange: (v: string) => void;
  period: HealthPeriod;
  onPeriodChange: (v: HealthPeriod) => void;
}

const selectClass =
  'border border-border rounded-lg px-3 py-2 text-sm bg-background focus:outline-none focus:ring-2 focus:ring-primary/40 min-w-[130px]';

const HealthFilterBar: React.FC<Props> = ({
  search,
  onSearchChange,
  healthFilter,
  onHealthFilterChange,
  usageFilter,
  onUsageFilterChange,
  tzFilter,
  onTzFilterChange,
  period,
  onPeriodChange,
}) => (
  <div className="rounded-xl border border-border bg-card/80 backdrop-blur-sm p-4 shadow-sm">
    <div className="flex items-center gap-2 mb-3 text-xs font-medium text-muted-foreground uppercase tracking-wide">
      <FunnelIcon className="h-3.5 w-3.5" />
      Filters
    </div>
    <div className="flex flex-wrap gap-3 items-center">
      <div className="relative flex-1 min-w-[220px] max-w-md">
        <MagnifyingGlassIcon className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <input
          className="w-full pl-9 pr-3 py-2.5 border border-border rounded-lg text-sm bg-background focus:outline-none focus:ring-2 focus:ring-primary/40"
          placeholder="Search number, area code, connection..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>
      <select
        className={`${selectClass} font-medium`}
        value={period}
        onChange={(e) => onPeriodChange(e.target.value as HealthPeriod)}
      >
        {HEALTH_PERIOD_OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>
      <select className={selectClass} value={healthFilter} onChange={(e) => onHealthFilterChange(e.target.value)}>
        <option value="all">All Statuses</option>
        <option value="healthy">Healthy</option>
        <option value="warning">Warning</option>
        <option value="replace">Replace</option>
        <option value="warm_up">Warm-Up</option>
        <option value="quarantine">Quarantine</option>
        <option value="retired">Retired</option>
        <option value="out_of_inventory">Out of Inventory</option>
      </select>
      <select className={selectClass} value={usageFilter} onChange={(e) => onUsageFilterChange(e.target.value)}>
        <option value="all">All Usage Types</option>
        <option value="voice">Voice</option>
        <option value="text">Text</option>
        <option value="ai">AI</option>
        <option value="follow_up">Follow-Up</option>
      </select>
      <select className={selectClass} value={tzFilter} onChange={(e) => onTzFilterChange(e.target.value)}>
        <option value="all">All Timezones</option>
        <option value="Eastern">Eastern</option>
        <option value="Central">Central</option>
        <option value="Mountain">Mountain</option>
        <option value="Pacific">Pacific</option>
        <option value="Unknown">Unknown</option>
        <option value="Other">Other</option>
      </select>
    </div>
  </div>
);

export default HealthFilterBar;
